var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "hamburger__line-1",
    width: 24,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 0)",
    fill: "#6A2D56",
    stroke: "#6A2D56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "hamburger__line-2",
    width: 24,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 9)",
    fill: "#6A2D56",
    stroke: "#6A2D56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "hamburger__line-3",
    width: 13,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 25 18)",
    fill: "#6A2D56",
    stroke: "#6A2D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon-hamburger.631b18eb.svg";
export { ForwardRef as ReactComponent };